var map = {
	"./automation-control-lab.js": 2116,
	"./computer-vision.js": 4777,
	"./happy-customers.js": 7203,
	"./linear-optimization.js": 5820,
	"./llm-finetuning.js": 2842,
	"./master-thesis.js": 9836,
	"./monreader.js": 9800,
	"./neural-networks.js": 1636,
	"./newsletter-automation.js": 6716,
	"./personal-website.js": 9085,
	"./potential-talent.js": 9870,
	"./precision-manufacturing.js": 6442,
	"./reinforcement-learning.js": 7603,
	"./rpa-automation.js": 6534,
	"./sales-reinforcer.js": 4739,
	"./salesforce-prompt-builder.js": 6211,
	"./software-engineering.js": 9442,
	"./tech-entrepreneurship.js": 5159,
	"./term-deposit-marketing.js": 9873,
	"./traffic-simulation.js": 1938,
	"./university-coding.js": 4844,
	"./value-investor.js": 509,
	"./voice-cloning.js": 4896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1400;